import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';

@Component({
  selector: 'app-add-custom-group-modal',
  templateUrl: './add-custom-group-modal.component.html',
  styleUrls: [
    './add-custom-group-modal.component.scss',
    '../../../../styles/shared-mpp-styles.scss',
  ],
})
export class AddCustomGroupModalComponent {
  @Output() dismissEvent: EventEmitter<void> = new EventEmitter();
  @Output() submitEvent: EventEmitter<string> = new EventEmitter();
  @Input() platform: PlatformEnum;
  @Input() recipeName: string;

  platformRef = PlatformEnum;
  customGroupName = '';
  containsEmojis = false;
  maxLength = 100;

  hasEmoji(text: string): boolean {
    return /\p{Extended_Pictographic}/gu.test(text);
  }

  onCustomGroupChange(text: string) {
    this.containsEmojis = this.hasEmoji(text);
    if (text.length > this.maxLength) {
      this.customGroupName = text.substring(0, this.maxLength);
    }
  }

  dismiss() {
    this.dismissEvent.emit();
  }

  submit() {
    if (!this.containsEmojis && this.customGroupName.trim()) {
      this.submitEvent.emit(this.customGroupName.trim());
    }
  }
}
